// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--3_xAz","title":"a10a3f92e9--title--1C0re","button":"a10a3f92e9--button--3COz8","show-all-link":"a10a3f92e9--show-all-link--Op2nZ"};